import { Controller } from "@hotwired/stimulus"

// Generic controller to disable a submit button and show a spinner
// Usage:
// <button
//   type="submit"
//   data-controller="submit-with-spinner"
//   data-action="submit->submit-with-spinner#handle submit-with-spinner:reset->submit-with-spinner#reset"
//   data-submit-with-spinner-target="button">
//   <span data-submit-with-spinner-target="content">...</span>
//   <span class="hidden" data-submit-with-spinner-target="spinner">...</span>
// </button>
export default class extends Controller {
  static targets = ["button", "content", "spinner"]

  handle() {
    // Already disabled → ignore duplicate submits
    if (this.hasButtonTarget && this.buttonTarget.disabled) return

    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
    }

    if (this.hasContentTarget && this.hasSpinnerTarget) {
      this.contentTarget.classList.add("hidden")
      this.spinnerTarget.classList.remove("hidden")
    }
  }

  reset() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = false
    }

    if (this.hasContentTarget && this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden")
      this.contentTarget.classList.remove("hidden")
    }
  }
}

